import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const getAllTeachers = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/teacher/getAllTeachers`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const createTeacher = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/teacher/register`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getTeacherById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/teacher/getTeacher/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateTeacher = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/teacher/updateTeacher/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteTeacher = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/teacher/deleteTeacher/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const modifyPassword = async (payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/teacher/modifyPassword`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};
// --------------------------Import/Export-------------------------------------------------------

export const importTeacherProfil = async (payload) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/importTeacher`,
    payload,
    {
      headers: { ...setHeaders(), "Content-Type": "multipart/form-data" },
      withCredentials: setHeaders().withCredentials,
    },
  );
  return response.data;
};

export const exportTeacherProfil = async () => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/exporte/teachers/excel`,
    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
      responseType: "blob",
    },
  );
  return response.data;
};

export const templateTeacher = async () => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/download/templateTeacher`,

    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
      responseType: "blob",
    },
  );
  return response.data;
};

/**PHASE 2 */
// --------------------------Taux horaire-------------------------------------------------------

export const createHourlyRate = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/hourlyRate/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateHourlyRate = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/hourlyRate/update/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteHourlyRate = async (id, context) => {
  const reponse = await axios.delete(
    apiPaths.baseUrl + `/api/hourlyRate/delete/${id}`,
    { headers: setHeaders(context) },
  );
  return reponse.data;
};

export const getTeacherHourlyRateByYear = async (
  id_teacherProfil,
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/hourlyRate/${id_academicYear}/${id_teacherProfil}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllHourlyRatesByYear = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/hourlyRate/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// ------------import/export HourlyRate--------------------------------------------------
export const templateTeacherHourlyRate = async () => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/importHourlyRate/template`,

    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
      responseType: "blob",
    },
  );
  return response.data;
};

export const importTeacherHourlyRate = async (
  id_academicYear,
  payload,
  context,
) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/importHourlyRate/${id_academicYear}`,
    payload,
    {
      headers: { ...setHeaders(), "Content-Type": "multipart/form-data" },
      withCredentials: setHeaders().withCredentials,
    },
  );
  return response.data;
};

export const exportTeacherHourlyRate = async (id_academicYear, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/exporte/rate/${id_academicYear}`,
    {},
    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
      responseType: "blob",
    },
  );
  return response.data;
};
// --------------------------Report-------------------------------------------------------

export const getMonthlyTeacherReport = async (
  id_teacherProfil,
  month,
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/coursedt/report/${id_teacherProfil}/${id_academicYear}/${month}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const generateMonthlyTeacherReportPdf = async (
  id_teacherProfil,
  month,
  year,
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/pdf/generate-teacher-report/${id_teacherProfil}/${id_academicYear}/${month}/${year}`,
    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
      responseType: "blob",
    },
  );
  return response.data;
};
